
const DesafioSemanal3 = () => {
  return (
    <div className="bg-white">

     <h4 className="mb-4" style={{ color: "#99CBC8" }}>
          <span
            style={{
            borderBottom: "3px solid #99CBC8",
            display: "inline-block",
            paddingBottom: "2px",
            }}
          >
            Desafio Semanal
          </span>
      </h4>
          <div className="mb-4 lead">
        <p className="mb-3 fw-bold">
          Queria lançar-te um desafio para esta semana!
        </p>
        <p className="mb-3">
          Cria <strong>lembretes com frases compassivas</strong> no teu telemóvel. Escreve
          uma <strong>frase compassiva</strong> que faça sentido para ti.
        </p>
        <p className="mb-3">
          Depois, <strong>vai ao calendário do teu telemóvel</strong> e cria um lembrete com
          a frase escolhida. Define <strong> a hora e os dias em que queres que o
          lembrete apareça </strong>, escolhendo momentos em que sabes que a tua voz
          crítica costuma surgir, como antes de um teste ou de uma
          apresentação.
        </p>
        <p className="mb-3">
          Estes lembretes vão ser uma ajuda para te lembrares de ser <strong>mais
          gentil contigo mesmo/a</strong>, especialmente nos momentos difíceis, e vão
          ajudar-te a <strong>lidar melhor com as tuas emoções</strong>.
        </p>
        <p className="mb-4">
         Espero que esta semana te ajude a aprofundar a <strong> tua prática de
          autocompaixão </strong>e a compreender melhor como ela pode  <strong> transformar a
          tua relação contigo mesmo/a.</strong>
        </p>

        <p className="fw-bold lead">Vamos em frente! #SêAmigoDeTiMesmo</p>
        <p>Até para a Semana!</p>
        </div>
    </div>
        
    );
};

export default DesafioSemanal3;
